// Reads the currently logged-in CMS user from localStorage
export const getCurrentUserLevel = () => {
    const current_user = JSON.parse(
        localStorage.getItem(`${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}user`)
    );
    return (current_user !== null && current_user.level !== undefined)
        ? current_user.level
        : '';
};

// A route/menu item with no "roles" is open to any authenticated user.
// Otherwise the user's level must match at least one of the allowed roles.
export const hasRequiredRole = (roles) => {
    if (!roles) return true;
    const userLevel = getCurrentUserLevel();
    return roles.some(role => userLevel.indexOf(role) !== -1);
};